import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ElementLocale from 'element-ui/lib/locale';
import { extractCountryCode } from '~/lib/extractCountryCode';

const language = extractCountryCode(document.documentElement.lang);
const { amount } = document.querySelector('html').dataset;

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: language,
  fallbackLocale: 'en',
  messages: {},
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  pluralizationRules: {
    cs: (choice) => {
      if (choice === 1) return 0;
      if (choice >= 2 && choice <= 4) return 1;
      return 2;
    },
  },
});

ElementLocale.i18n((key, value) => i18n.t(key, value));

export function loadTranslations() {
  return import(/* webpackChunkName: "lang-[request]" */ `~/int/${language}/${language}.js`).then(
    (data) => {
      i18n.setLocaleMessage(language, data.default[language]);
      const amounts = JSON.parse(amount);

      i18n.mergeLocaleMessage(language, {
        amounts: {
          mini: amounts.mini.toString(),
          premium: amounts.premium.toString(),
        },
      });

      i18n.locale = language;
    },
  );
}

export default i18n;
